import { render, staticRenderFns } from "./LinkOrderChoose.vue?vue&type=template&id=f6b6bfda&scoped=true"
import script from "./LinkOrderChoose.vue?vue&type=script&lang=js"
export * from "./LinkOrderChoose.vue?vue&type=script&lang=js"
import style0 from "./LinkOrderChoose.vue?vue&type=style&index=0&id=f6b6bfda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b6bfda",
  null
  
)

export default component.exports